export const environment = {
  production: false,
  COGNITO_REGION: 'us-west-2',
  COGNITO_POOL_ID: 'us-west-2_QhK5zJXFq',
  COGNITO_CLIENT_ID: '525qts49suiop3r7vkkafmc6ji',
  COGNITO_IDENTITY_POOL_ID: 'us-west-2:a6585423-a5f8-4487-bea3-1df972e1b364',
  AURORA_API: 'https://6aj6xp6b12.execute-api.us-west-2.amazonaws.com/dev/v1',
  AURORA_S3: 'https://truscan-dev.s3.amazonaws.com',
  AURORA_S3_SPECTRA: 'aurora-dev-reference-spectra',
  AURORA_API_TEST: 'https://6aj6xp6b12.execute-api.us-west-2.amazonaws.com/test/v1'
};
